import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15a63c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-summary" }
const _hoisted_2 = { class: "order-summary__header-container" }
const _hoisted_3 = { class: "order-summary__header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "order-summary__products" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "order-summary__product__info-container" }
const _hoisted_8 = { class: "order-summary__product__header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "order-summary__product__artno" }
const _hoisted_11 = { class: "order-summary__product__buy-container" }
const _hoisted_12 = { class: "order-summary__product__quantity" }
const _hoisted_13 = { class: "order-summary__price-header" }
const _hoisted_14 = { class: "order-summary__discount-code-container" }
const _hoisted_15 = { class: "order-summary__discount-code" }
const _hoisted_16 = { class: "text-input" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "order-summary__discount-validation order-summary__discount-validation--success"
}
const _hoisted_19 = {
  key: 1,
  class: "order-summary__discount-validation order-summary__discount-validation--error"
}
const _hoisted_20 = {
  key: 2,
  class: "button button--default order-summary__discount-submit",
  type: "submit"
}
const _hoisted_21 = { class: "order-summary__total-container" }
const _hoisted_22 = { class: "order-summary__total-container-term" }
const _hoisted_23 = { class: "order-summary__total-container-definition" }
const _hoisted_24 = { class: "order-summary__total-container-term order-summary__total-container-term--discount" }
const _hoisted_25 = { class: "order-summary__total-container-definition order-summary__total-container-definition--discount" }
const _hoisted_26 = {
  key: 0,
  class: "order-summary__total-container-term"
}
const _hoisted_27 = {
  key: 1,
  class: "order-summary__total-container-definition"
}
const _hoisted_28 = { class: "order-summary__total-container-term order-summary__total-container-term--small" }
const _hoisted_29 = { class: "order-summary__total-container-definition order-summary__total-container-definition--small" }
const _hoisted_30 = {
  key: 3,
  class: "order-summary__freight-info-container"
}
const _hoisted_31 = {
  key: 2,
  class: "order-summary__freight-info-container"
}
const _hoisted_32 = { class: "order-summary__total-container" }
const _hoisted_33 = { class: "order-summary__total-container-term order-summary__total-container-term--big order-summary__total-container-term--total" }
const _hoisted_34 = { class: "order-summary__total-container-definition order-summary__total-container-definition--big" }
const _hoisted_35 = {
  key: 0,
  class: "order-summary__total-container-term order-summary__total-container-term--small"
}
const _hoisted_36 = {
  key: 1,
  class: "order-summary__total-container-definition order-summary__total-container-definition--small"
}

import dictionary from "@/i18n/dictionary.json";
import { computed, inject, onMounted, ref, watch } from "vue";
import TressAlert from "@/components/TressAlert.vue";
import IconInfo from "@/components/icons/IconInfo.vue";
import { CustomerType } from "@/enums/CustomerType";
import { useI18n } from "vue-i18n";
import { AmountAndVat, CartRow } from "@/models/Cart";
import { useCart } from "@/store/useCart";
import { Emitter } from "mitt";
import { useCheckout } from "@/store/useCheckout";

enum DiscountCodeStatus {
  Unknown,
  Valid,
  Invalid,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TressOrderSummary',
  props: {
  alwaysShowFreightFee: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props;

const $t = useI18n().t;



const checkout = useCheckout();
const customerType = window.customerType;
const discountCodeRef = ref<HTMLInputElement | undefined>(undefined);
const basket = useCart();
const discountCodeStatus = ref<DiscountCodeStatus>(DiscountCodeStatus.Unknown);
const showDiscountCode = ref<boolean>(false);
const discountCodeButtonEnabled = ref<boolean>(false);

const getRowPrice = (item: CartRow) => (customerType === CustomerType.Private ? item.priceIncVat : item.price);

const getProductPreviousPrice = (item) =>
  customerType === CustomerType.Private ? item.originalPriceIncVat : item.originalPrice;

const getSummaryPrice = (item: AmountAndVat) =>
  customerType === CustomerType.Private ? item.amountIncVat : item.amount;

const getFreightPrice = () => {
  if (deliveryMethodSelected.value) {
    return customerType === CustomerType.Private ? basket.summary.freight.amountIncVat : basket.summary.freight.amount;
  } else if (showCheapestFreightFee.value) {
    return `${$t(dictionary.common.from)} ${customerType === CustomerType.Private ? basket.summary.freight.amountIncVat : basket.summary.freight.amount
      }`;
  } else if (showDefaultFreightFee.value) {
    return `${$t(dictionary.common.from)} ${customerType === CustomerType.Private ? basket.summary.freight.amountIncVat : basket.summary.freight.amount
      }*`;
  } else {
    return $t(dictionary.checkout.calculatingFreightFee);
  }
};

const vatText = () =>
  customerType === CustomerType.Private ? $t(dictionary.common.includeVat) : $t(dictionary.common.excludeVat);

async function resetDiscountCode() {
  basket.discountCode = "";
  discountCodeButtonEnabled.value = true;
  await submitDiscountCode();
  basket.discountCodeHasBeenApplied = false;
}

const deliveryMethodSelected = computed(() => {
  return checkout.deliveryMethodId;
});

const showFreightFee = computed(() => {
  return props.alwaysShowFreightFee || !basket.hasSpecialFreight;
});

const showDefaultFreightFee = computed(() => {
  return !basket.hasSelectedDeliveryMethod && !checkout.shippingPostalCode;
});

const showCheapestFreightFee = computed(() => {
  return !basket.hasSelectedDeliveryMethod && checkout.shippingPostalCode;
});

const onDiscountCodeFocus = () => {
  discountCodeButtonEnabled.value = true;
  discountCodeStatus.value = DiscountCodeStatus.Unknown;
};

onMounted(() => {
  if (basket.discountCode) {
    showDiscountCode.value = true;
    basket.discountCodeHasBeenApplied = true;
    discountCodeStatus.value = DiscountCodeStatus.Valid;
  }
});

const submitDiscountCode = async () => {
  document.documentElement.focus();
  discountCodeStatus.value = DiscountCodeStatus.Unknown;
  const discountCode = basket.discountCode.toUpperCase();
  await basket.setDiscountCode(discountCode);
  if (discountCode !== "") {
    // If a non-empty code was submitted we determine its status dependent on whether or not it
    // equals the code on the basket (non-empty code means a successful valid code).
    discountCodeStatus.value =
      discountCode === basket.discountCode ? DiscountCodeStatus.Valid : DiscountCodeStatus.Invalid;

    if (discountCodeStatus.value === DiscountCodeStatus.Valid) {
      basket.discountCodeHasBeenApplied = true;
      discountCodeButtonEnabled.value = false;
    }
  }
  if (discountCodeStatus.value === DiscountCodeStatus.Invalid) {
    // To show the invalid code in the input field we reset the discount code on the basket
    basket.discountCode = discountCode;
  }
};

watch(showDiscountCode, (value: boolean) => {
  if (value) {
    setTimeout(() => {
      if (discountCodeRef.value && !basket.discountCode) {
        discountCodeRef.value.focus();
      }
    }, 0);
  }
});

const emitter = inject<Emitter<any>>("eventbus")!;
const onCartOpenClick = () => {
  emitter.emit("openCart");
};

return (_ctx: any,_cache: any) => {
  const _component_icon_chevron_down = _resolveComponent("icon-chevron-down")!
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref($t)(_unref(dictionary).common.myOrder)), 1),
      _createElementVNode("button", {
        class: "order-summary__edit",
        onClick: onCartOpenClick
      }, _toDisplayString(_unref($t)(_unref(dictionary).common.editContent)), 1)
    ]),
    (_unref(basket).hasRemovedItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref($t)(_unref(dictionary).checkout.itemsHasBeenRemoved)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(basket).rows, (row) => {
        return (_openBlock(), _createElementBlock("li", {
          key: row.item.partNo,
          class: "order-summary__product"
        }, [
          (row.item.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: row.item.imageUrl,
                class: "order-summary__product__image"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(row.item.name) + " ", 1),
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(row.item.partNo), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref($t)(_unref(dictionary).common.quantity)) + ": " + _toDisplayString(row.quantity), 1),
              _createElementVNode("p", {
                class: _normalizeClass([{ 'order-summary__product__price--discount': row.item.originalPrice }, "order-summary__product__price"])
              }, [
                (row.item.originalPrice)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(_unref(basket).discountCodeHasBeenApplied || row.item.discountPercent ? 
                  'order-summary__product__price--without-discount-code' :
                  'order-summary__product__price--with-discount-code')
                    }, _toDisplayString(getProductPreviousPrice(row)), 3))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(getRowPrice(row)), 1)
              ], 2)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref($t)(_unref(dictionary).common.priceOverview)), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDiscountCode).value = $event)),
          class: "order-summary__discount-code-checkbox",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, showDiscountCode.value]
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref($t)(_unref(dictionary).checkout.addDiscountCode)), 1),
        _createVNode(_component_icon_chevron_down, {
          class: _normalizeClass({ 'icon-chevron-down--open': showDiscountCode.value })
        }, null, 8, ["class"])
      ]),
      (showDiscountCode.value)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 0,
            onSubmit: submitDiscountCode
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                'text-input__container--error': discountCodeStatus.value === DiscountCodeStatus.Invalid,
                'text-input__container--success': discountCodeStatus.value === DiscountCodeStatus.Valid,
              }, "text-input__container"])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "discountCodeRef",
                    ref: discountCodeRef,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(basket).discountCode) = $event)),
                    placeholder: _unref($t)(_unref(dictionary).checkout.addDiscountCodeLabel),
                    onFocus: onDiscountCodeFocus,
                    class: "order-summary__discount-code-input"
                  }, null, 40, _hoisted_17), [
                    [
                      _vModelText,
                      _unref(basket).discountCode,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (discountCodeStatus.value !== DiscountCodeStatus.Unknown)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "order-summary__discount-reset",
                        type: "button",
                        onClick: resetDiscountCode
                      }, [
                        _createVNode(_component_icon_close)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              (discountCodeStatus.value === DiscountCodeStatus.Valid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref($t)(_unref(dictionary).checkout.validDiscountCode)), 1))
                : _createCommentVNode("", true),
              (discountCodeStatus.value === DiscountCodeStatus.Invalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref($t)(_unref(dictionary).checkout.invalidDiscountCode)), 1))
                : _createCommentVNode("", true),
              (discountCodeButtonEnabled.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_20, _toDisplayString(_unref($t)(_unref(dictionary).checkout.addDiscountCodeSubmit)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dl", _hoisted_21, [
      _createElementVNode("dt", _hoisted_22, _toDisplayString(_unref($t)(_unref(dictionary).common.subtotal)), 1),
      _createElementVNode("dd", _hoisted_23, _toDisplayString(getSummaryPrice(_unref(basket).summary.originalTotal)), 1),
      (_unref(basket).summary.totalDiscounts?.amount)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("dt", _hoisted_24, _toDisplayString(_unref($t)(_unref(dictionary).common.totalDiscount)), 1),
            _createElementVNode("dd", _hoisted_25, " - " + _toDisplayString(getSummaryPrice(_unref(basket).summary.totalDiscounts)), 1)
          ], 64))
        : _createCommentVNode("", true),
      (showFreightFee.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(checkout).shippingPostalCode)
              ? (_openBlock(), _createElementBlock("dt", _hoisted_26, _toDisplayString(_unref($t)(_unref(dictionary).common.freight)), 1))
              : _createCommentVNode("", true),
            (_unref(checkout).shippingPostalCode)
              ? (_openBlock(), _createElementBlock("dd", _hoisted_27, _toDisplayString(getFreightPrice()), 1))
              : _createCommentVNode("", true),
            (_unref(customerType) == _unref(CustomerType).Private)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("dt", _hoisted_28, " - " + _toDisplayString(_unref($t)(_unref(dictionary).common.ofWhichVat)), 1),
                  _createElementVNode("dd", _hoisted_29, _toDisplayString(_unref(basket).summary.total.vat), 1)
                ], 64))
              : _createCommentVNode("", true),
            (showDefaultFreightFee.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(TressAlert, { success: "" }, {
                    default: _withCtx(() => [
                      _createVNode(IconInfo),
                      _createTextVNode(" " + _toDisplayString(_unref($t)(_unref(dictionary).checkout.freightPriceCanChangeDependingOnDeliveryAddress)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createVNode(TressAlert, { success: "" }, {
              default: _withCtx(() => [
                _createVNode(IconInfo),
                _createTextVNode(" " + _toDisplayString(_unref($t)(_unref(dictionary).checkout.basketHasSpecialFreight)), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("dl", _hoisted_32, [
      _createElementVNode("dt", _hoisted_33, [
        _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).common.totalPrice)) + " ", 1),
        _createElementVNode("span", null, "(" + _toDisplayString(vatText()) + ")", 1)
      ]),
      _createElementVNode("dd", _hoisted_34, _toDisplayString(getSummaryPrice(_unref(basket).summary.total)), 1),
      (_unref(customerType) === _unref(CustomerType).Business)
        ? (_openBlock(), _createElementBlock("dt", _hoisted_35, _toDisplayString(_unref($t)(_unref(dictionary).common.vat)), 1))
        : _createCommentVNode("", true),
      (_unref(customerType) === _unref(CustomerType).Business)
        ? (_openBlock(), _createElementBlock("dd", _hoisted_36, _toDisplayString(_unref(basket).summary.total.vat), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})